import apiClient from './apiClient';
const URL = process.env.REACT_APP_API_URL + "/notas-autorizacion";


export const subirNotaDeAutorizacion = async (archivo) => {
  const formData = new FormData();
  formData.append("archivo", archivo);
  try {
    const response = await apiClient(`${URL}`, {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message);
    }

    return data;
  } catch (error) {
    throw error;
  }
}


export const autorizar = async (data) => {
  try {
    const response = await apiClient(`${URL}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    if (response.status !== 201) {
      throw new Error("Error al autorizar la nota de autorizacion");
    }

    return true;
  } catch (error) {
    throw error;
  }
}
